import React, { useState } from "react";
import { Container, Row, Col, Nav, Card } from "react-bootstrap";
import CommonNavbar from "../CommonLayout/CommonNavbar";
import CommonFooter from "../CommonLayout/CommonFooter";

const Documentation = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const renderContent = () => {
    switch (activeTab) {
      case "overview":
        return (
          <>
            <h3>Overview</h3>
            <p>
              The Psycho Oncology Appointment Platform is a comprehensive SaaS solution
              designed for mental health professionals and their clients. The system enables counsellors to
              manage their availability (weekly and date-specific) and connect their personal Zoom accounts.
              When clients book appointments, the system automatically generates a unique Zoom meeting link,
              integrates with a secure payment gateway, and records appointment details.
            </p>
            <p>
              This documentation covers the end-to-end functionality of the platform, including user registration,
              scheduling, Zoom integration, and appointment booking. The platform is built to ensure ease of use,
              data security, and efficient service delivery for both counsellors and clients.
            </p>
          </>
        );
      case "setup":
        return (
          <>
            <h3>Setup &amp; Configuration</h3>
            <p>
              To get started, both counsellors and clients must register on the platform. Counsellors are required to complete a profile with their professional details and connect their Zoom account via our secure OAuth flow.
            </p>
            <ul>
              <li>
                <b>Account Registration:</b> Users register by providing their personal details which are stored in our secure Server.
              </li>
              <li>
                <b>Zoom Integration:</b> Counsellors connect their Zoom account by clicking "Connect Zoom" in the settings.
                The OAuth flow securely retrieves Zoom tokens that are stored in our secure server.
              </li>
              <li>
                <b>Payment Gateway:</b> Clients will be able to pay for their appointments through an integrated secure payment gateway.
              </li>
            </ul>

          </>
        );
      case "userguide":
        return (
          <>
            <h3>User Guide</h3>
            <p>
              The platform offers two primary user flows – one for counsellors and one for clients.
            </p>
            <ul>
              <li>
                <b>Counsellor Flow:</b> Register as a counsellor, complete your profile, set your weekly or date-specific availability,
                and connect your Zoom account to enable automatic meeting link generation.
              </li>
              <li>
                <b>Client Flow:</b> Register as a client, browse available counsellors, and book appointments at your preferred time.
                Once an appointment is booked, you receive an appointment confirmation and a Zoom meeting link.
              </li>
            </ul>

          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <CommonNavbar />
      <Container style={{ padding: "30px", marginTop: "20px" }}>
        <Row>
          {/* Sidebar Navigation */}
          <Col md={3}>
            <Nav
              variant="pills"
              className="flex-column"
              activeKey={activeTab}
              onSelect={(selectedKey) => setActiveTab(selectedKey)}
            >
              <Nav.Item>
                <Nav.Link eventKey="overview">Overview</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="setup">Setup &amp; Configuration</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="userguide">User Guide</Nav.Link>
              </Nav.Item>

            </Nav>
          </Col>

          {/* Documentation Content */}
          <Col md={9}>
            <Card className="shadow-sm">
              <Card.Body>{renderContent()}</Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <CommonFooter />
    </>
  );
};

export default Documentation;
